import React from 'react'
import Button from '../button'
import CustomAnchor from '../custom-anchor'
import PopoverInfo from '../popover-info'
import ProgressBar from '../progress-bar'
import UnlockPremimumButton from '../unlock-premium-button'
import { useFakeProgress } from '../../hooks'

const UNLOCK_CALENDLY_URL = "https://calendly.com/cheli-w/30-min-meeting"

const CANCEL_PROCESS_HELP = (
  <>
    <img src="/images/icon/failed.svg" alt="" className="ai-processing-help-icon" />
    <span>
      If the AI ingestion process is keep on failing, click 'cancel process' to get back to the chat.
      <br />
      The Bimmatch support-team will follow this specific case and get back to you by one workday. Thank you for your patience.
    </span>
  </>
)

// Which of the AI states a docs view is in, or nothing when the chat is free.
const AiProcessingState = ({ isAiLocked, isAiProcessing, failedRun, refreshRuns, isRefreshing, retryRun, isRetrying, cancelRun, isCancelling, stacked }) => {
  if (isAiLocked) return <AiLockedBanner stacked={stacked} />
  if (isAiProcessing) return <AiProcessingLoader onRefresh={refreshRuns} isRefreshing={isRefreshing} />
  if (failedRun) return <AiProcessingFailed onRetry={retryRun} isRetrying={isRetrying} onCancel={cancelRun} isCancelling={isCancelling} />
  return null
}

const AiLockedBanner = ({ stacked }) => (
  <div className={`ai-locked-banner ${stacked ? 'ai-locked-banner-stacked' : ''}`}>
    <div className="ai-locked-message">
      <img className="ai-locked-icon" src="/images/icon/gotcha.svg" alt="unlock-ai" />
      <span>Chat with the entire data of your project as one source of truth - ask anything and gain a full clarity of your project.</span>
    </div>
    <UnlockPremimumButton name="Unlock" href={UNLOCK_CALENDLY_URL} />
  </div>
)

const CancelProcess = ({ onCancel, isCancelling, help }) => (
  <div className="ai-processing-cancel">
    <CustomAnchor onClick={isCancelling ? undefined : onCancel} className="ai-processing-support">
      {isCancelling ? "Cancelling..." : "Cancel process"}
    </CustomAnchor>
    <PopoverInfo message={help} className="ai-processing-help" placement="right" width={300} />
  </div>
)

const AiProcessingLoader = ({ onRefresh, isRefreshing }) => {
  const progress = useFakeProgress(true)

  return (
    <div className="ai-processing-panel">
      <h3 className="ai-processing-title">AI data processing...</h3>
      <ProgressBar progress={progress} />
      <AiProcessingNote iconSrc="/images/icon/coffee.svg">Each document takes an average of 1 to 2 minutes of processing ...time for a short break</AiProcessingNote>
      <Button onClick={onRefresh} loading={isRefreshing}>Refresh</Button>
    </div>
  )
}

export const AiProcessingNote = ({ iconSrc, children }) => (
  <div className="ai-processing-note">
    <img className="waiting-icon" src={iconSrc} alt="" />
    <span>{children}</span>
  </div>
)

const AiProcessingFailed = ({ onRetry, isRetrying, onCancel, isCancelling }) => (
  <div className="ai-processing-panel">
    <h3 className="ai-processing-title ai-processing-failed-title">AI data processing failed</h3>
    <Button onClick={onRetry} loading={isRetrying} disable={isCancelling}>Try again</Button>
    <CancelProcess onCancel={onCancel} isCancelling={isCancelling} help={CANCEL_PROCESS_HELP} />
  </div>
)

export default AiProcessingState
